import React, { useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    SelectHotelNights,
    SelectHotelRange,
    SelectHotelRoomType,
} from '../../../actions/hotels';

import {
    NightsSelector,
} from '../../../components/single-product/hotels/NightsSelector';
import {
    RangesSelector,
} from '../../../components/single-product/hotels/RangesSelector';
import {
    RoomSelector,
} from '../../../components/single-product/hotels/RoomSelector';
import { useOnDismiss } from '../../../hooks/useOnDismiss.js';

export function HotelFilters() {
    const filters = useRef(null);

    const [showFiltersForMobile, setShowFiltersForMobile] = useState(false);

    const availableNights = useSelector(state => state.hotels.available_nights);
    const availableDays = useSelector(state => state.hotels.available_days);

    const selectedHotelNights = useSelector(state => state.hotels.selected_hotel_nights);
    const selectedHotelRange = useSelector(state => state.hotels.selected_hotel_range);
    const selectedHotelRoomType = useSelector(state => state.hotels.selected_hotel_room_type);

    const numberOfGuests = useSelector(state => state.cart.confirmed_tickets.length);

    const dispatch = useDispatch();

    const unevenNumberOfGuests = numberOfGuests % 2 !== 0;

    useOnDismiss(
        filters,
        showFiltersForMobile,
        useCallback(
            () => setShowFiltersForMobile(false),
            [setShowFiltersForMobile],
        ),
    );

    return (
        <>
            <div
                className="night-and-day-picker px-3 py-2 bg-white rounded flex flex-wrap justify-between gap-y-2"
                ref={filters}
            >
                <NightsSelector
                    nights={availableNights}
                    value={selectedHotelNights}
                    onChange={value => dispatch(SelectHotelNights(value))}
                />
                <div className="flex flex-wrap gap-y-2 gap-x-3 maxmd:basis-full md:ml-4 md:flex-1">
                    <RangesSelector
                        days={availableDays}
                        value={selectedHotelRange}
                        index={selectedHotelNights}
                        onChange={value => dispatch(SelectHotelRange(value))}
                    />
                    {unevenNumberOfGuests && (
                        <RoomSelector
                            numberOfGuests={numberOfGuests}
                            value={selectedHotelRoomType}
                            onChange={value => dispatch(SelectHotelRoomType(
                                value))}
                        />
                    )}
                </div>
            </div>
        </>
    );
}
